import React from 'react';

import Skeleton from '@material-ui/lab/Skeleton';
import { Paper } from '@material-ui/core';

export default function ArticleSkeleton(props) {

    const { isMobile } = props

    return (
        <Paper style={{ padding: 24, marginBottom: 24 }}>
            <Skeleton height={32} width="30%" animation="wave" style={{ marginBottom: 2 }}/>
            <Skeleton height={18} width="10%" animation="wave" style={{ marginBottom: 12 }}/>
            <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 2 }}/>
            <Skeleton height={24} width="100%" animation="wave" style={{ marginBottom: 2 }}/>
            <Skeleton height={24} width="20%" animation="wave" style={{ marginBottom: 12 }}/>
            <Skeleton height={18} width="10%" animation="wave"/>
        </Paper>
    )
}
